import { render, staticRenderFns } from "./wxpay_h5.vue?vue&type=template&id=0f0b8186&scoped=true"
import script from "./wxpay_h5.vue?vue&type=script&lang=js"
export * from "./wxpay_h5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0b8186",
  null
  
)

export default component.exports